import "react-datepicker/dist/react-datepicker.css";
import { Timestamp } from "firebase/firestore";
import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { date } from "yup";
import * as Yup from "yup";

interface DateTimePickerProps {
  startNote: string;
  endNote: string;
  onStartDateChanged: (date: Date | undefined) => void;
  onEndDateChanged: (date: Date | undefined) => void;
  startTimestamp?: Timestamp;
  endTimestamp?: Timestamp;
  disabled?: boolean;
}

export const DateTimePicker = ({
  startNote,
  endNote,
  onStartDateChanged,
  onEndDateChanged,
  startTimestamp,
  endTimestamp,
  disabled = false,
}: DateTimePickerProps) => {
  // const [finalStartDate, setFinalStartDate] = useState<Date | null>(new Date());
  // const [finalEndDate, setFinalEndDate] = useState<Date | null>(new Date());
  const [startDate, setStartDate] = useState<Date | undefined>(undefined);
  const [endDate, setEndDate] = useState<Date | undefined>(undefined);
  const [startTime, setStartTime] = useState<Date | undefined>(undefined);
  const [endTime, setEndTime] = useState<Date | undefined>(undefined);
  // const [hasInitialized, setHasInitialized] = useState(false);

  // useEffect(() => {
  //   schema
  //     .validate({ startDate, endDate })
  //     .then(() => console.log("Validation passed!"))
  //     .catch(err => console.error("Validation error:", err.errors));
  // }, [startDate, endDate]);

  useEffect(() => {
    // const convertTimestampToDate = (timestamp: Timestamp | null) => {
    //   return timestamp ? timestamp.toDate() : null;
    // };

    // if (!hasInitialized) {
    if (!startDate) {
      if (startTimestamp) {
        setStartDate(startTimestamp.toDate());
        // const sTime = mergeDateWithTime(new Date(), startTimestamp.toDate());
        // setStartTime(sTime);
      }
    }
    if (!startTime) {
      if (startTimestamp) {
        const sTime = mergeDateWithTime(new Date(), startTimestamp.toDate());
        setStartTime(sTime);
      }
    }

    if (!endDate) {
      if (endTimestamp) {
        setEndDate(endTimestamp.toDate());
        // const eTime = mergeDateWithTime(new Date(), endTimestamp.toDate());
        // setEndTime(eTime);
      }
    }

    if (!endTime) {
      if (endTimestamp) {
        const eTime = mergeDateWithTime(new Date(), endTimestamp.toDate());
        setEndTime(eTime);
      }
    }
    // }
  }, [startTimestamp, endTimestamp, startDate, endDate, startTime, endTime]);

  const isSameDay = (date1: Date, date2: Date) => {
    return date1.getDate() === date2.getDate() && date1.getMonth() === date2.getMonth() && date1.getFullYear() === date2.getFullYear();
  };

  const mergeDateWithTime = (t1: Date, t2: Date): Date => {
    const date = new Date(t1); // Create a new Date object based on t1 to avoid mutating the original

    // Set the time of t2 into t1
    const hours = t2.getHours();
    const mins = t2.getMinutes();
    date.setHours(hours);
    date.setMinutes(mins);
    date.setSeconds(0);
    date.setMilliseconds(0);
    console.log(`${hours} : ${mins}`);

    return date; // Return the new Date object
  };

  const handleStartDateChange = (date: Date) => {
    // setHasInitialized(true);
    setStartDate(date);
    if (startTime) {
      const newDate = mergeDateWithTime(date, startTime);
      onStartDateChanged(newDate);
    } else {
      onStartDateChanged(date);
    }

    if (date && date.getTime() > (endDate?.getTime() || 0)) {
      setEndDate(undefined);
      setEndTime(undefined);
    }
  };

  const handleStartTimeChange = (time: Date) => {
    // setHasInitialized(true);
    setStartTime(time);
    if (startDate) {
      const newDate = mergeDateWithTime(startDate, time);
      onStartDateChanged(newDate);
    } else {
      onStartDateChanged(time);
    }

    if (endDate && endDate.getTime() === (startDate?.getTime() || 0) && time && time.getTime() > (endTime?.getTime() || 0)) {
      setEndTime(undefined);
    }
  };

  const handleEndDateChange = (date: Date) => {
    // setHasInitialized(true);
    setEndDate(date);
    if (endTime) {
      const newDate = mergeDateWithTime(date, endTime);
      onEndDateChanged(newDate);
    } else {
      onEndDateChanged(date);
    }

    if (date && date.getTime() === (startDate?.getTime() || 0) && endTime && endTime.getTime() < (startTime?.getTime() || 0)) {
      setEndTime(undefined);
    }
  };

  const handleEndTimeChange = (time: Date) => {
    // setHasInitialized(true);
    setEndTime(time);
    if (endDate) {
      const newDate = mergeDateWithTime(endDate, time);
      onEndDateChanged(newDate);
    }
  };

  return (
    <div className="relative w-full min-w-[200px]">
      <div className="flex flex-col">
        <div className="notes-class-content">{startNote}</div>
        <div className="flex flex-row gap-3 mb-[15px]">
          <DatePicker
            selected={startDate}
            onChange={handleStartDateChange}
            minDate={new Date()}
            dateFormat="MMMM d, yyyy"
            className="h-10 px-2 py-1 border rounded location_dtpic_title"
            popperClassName="ml-8"
            disabled={disabled}
          />
          <DatePicker
            selected={startTime}
            onChange={handleStartTimeChange}
            showTimeSelect
            showTimeSelectOnly
            timeIntervals={15}
            minTime={startDate && isSameDay(startDate, Timestamp.now().toDate()) ? new Date() : new Date(0, 0, 0, 0, 0)}
            maxTime={new Date(0, 0, 0, 23, 59)}
            dateFormat="h:mm aa"
            className="location_dtpic_title"
            popperClassName="ml-8"
            disabled={disabled}
          />
        </div>
        <div className="notes-class-content">{endNote}</div>
        <div className="flex flex-row gap-3">
          <DatePicker
            selected={endDate}
            onChange={handleEndDateChange}
            minDate={startDate}
            dateFormat="MMMM d, yyyy"
            className="location_dtpic_title"
            popperClassName="ml-8"
            disabled={disabled}
          />
          <DatePicker
            selected={endTime}
            onChange={handleEndTimeChange}
            showTimeSelect
            showTimeSelectOnly
            timeIntervals={15}
            minTime={endDate && isSameDay(endDate, Timestamp.now().toDate()) ? new Date() : new Date(0, 0, 0, 0, 0)}
            // minTime={startDate && endDate && startDate.toDateString() === endDate.toDateString() && startTime ? startTime : new Date(0, 0, 0, 20, 0)}
            maxTime={new Date(0, 0, 0, 23, 59)}
            dateFormat="h:mm aa"
            className="location_dtpic_title"
            popperClassName="ml-8"
            disabled={disabled}
          />
        </div>
      </div>
    </div>
  );
};
